import { forwardRef, type InputHTMLAttributes } from 'react'

import { cn } from '@/lib/utils.ts'

export const Input = forwardRef<HTMLInputElement, InputHTMLAttributes<HTMLInputElement>>(
  ({ className, type, ...props }, ref) => (
    <input
      type={type}
      className={cn(
        'rounded-allocated-radius flex h-9 w-full border border-gray-200 bg-transparent px-3 py-1 text-sm text-gray-500 transition-colors placeholder:text-gray-300 focus-visible:ring-1 focus-visible:ring-gray-500 focus-visible:outline-hidden disabled:cursor-not-allowed disabled:opacity-50',
        className
      )}
      ref={ref}
      {...props}
    />
  )
)
